import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import SignupButton from 'pricing-pages-ui/components/common/SignupButton';
import SkeletonLoadWrapper from 'pricing-pages-ui/components/common/loading/SkeletonLoadWrapper';
import { hasPricingAndPurchasingSucceededSelector } from 'pricing-pages-ui/selectors/LoadingStateSelectors';
import { useSelector } from 'react-redux';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { ownsCrmSuiteProductLevel } from '../../selectors/ProductInventorySelectors';
import { SectionTitle } from '../common/SharedComponents';
import CurrentPlanButton from '../suite-starter-page/CurrentPlanButton';
import { FillerRow, MerchCardWrapper, Section } from './MerchCardSharedComponents';
import SuiteBusinessObjectives from './business-objectives/SuiteBusinessObjectives';
import HighlightedFreePriceDisplay from './price-display/HighlightedFreePriceDisplay';

const SuiteFreeTile = ({
  commonStyles,
  isFreeToStarter
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const isCurrentPlanLevel = useSelector(state => ownsCrmSuiteProductLevel(state, {
    productLevel: 'FREE'
  })); // In order for the grid to work, the wrapper element requires display: contents.
  // Children of the display grid item must get the grid-start attributes directly

  return /*#__PURE__*/_jsxs(MerchCardWrapper, {
    isFreeToStarter: isFreeToStarter,
    children: [/*#__PURE__*/_jsx(Section, {
      className: "p-top-8",
      style: Object.assign({
        position: 'relative',
        gridRowStart: 1
      }, commonStyles),
      children: /*#__PURE__*/_jsx(SectionTitle, {
        className: "m-all-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.freeCard.title"
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-top-6",
      style: Object.assign({
        gridRowStart: 2
      }, commonStyles),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.suiteTile.freeCard.description"
      })
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-top-4",
      style: Object.assign({
        gridRowStart: 3
      }, commonStyles),
      children: /*#__PURE__*/_jsx(HighlightedFreePriceDisplay, {
        perMonth: false
      })
    }), /*#__PURE__*/_jsx(FillerRow, {
      row: 4,
      commonStyles: commonStyles
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-top-4",
      style: Object.assign({
        gridRowStart: 5
      }, commonStyles),
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !hasPricingAndPurchasingSucceeded,
        heights: [47],
        children: isFreeToStarter && isCurrentPlanLevel ? /*#__PURE__*/_jsx(CurrentPlanButton, {
          ctaStyles: {
            width: '100%',
            lineHeight: '23px'
          }
        }) : /*#__PURE__*/_jsx(SignupButton, {
          sourceId: "pricing-hero",
          productLine: "crm",
          use: "primary",
          style: {
            width: '100%',
            lineHeight: '23px'
          }
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-bottom-6 flex flex-column align-center",
      style: Object.assign({}, commonStyles, {
        gridRowStart: 6
      })
    }), /*#__PURE__*/_jsx(Section, {
      className: "p-bottom-6 flex flex-column",
      style: Object.assign({}, commonStyles, {
        gridRowStart: 7
      })
    }), /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: !hasPricingAndPurchasingSucceeded,
      heights: [47],
      children: /*#__PURE__*/_jsx(SuiteBusinessObjectives, {
        productLevel: FREE,
        commonStyles: commonStyles
      })
    }), /*#__PURE__*/_jsx(Section, {
      style: Object.assign({}, commonStyles)
    })]
  });
};

export default SuiteFreeTile;